'use client';

import { Button } from '@/components/ui/button';
import Link from 'next/link';
import { ArrowRight, Bot, Sparkles } from 'lucide-react';

export function CtaSection() {
	return (
		<section className="py-20 px-4 sm:px-6 lg:px-8">
			<div className="max-w-7xl mx-auto">
				<div className="bg-gradient-to-br from-purple-600 via-blue-600 to-indigo-700 rounded-3xl p-8 md:p-16 text-center text-white relative overflow-hidden">
					{/* Background decoration */}
					<div className="absolute inset-0 opacity-10">
						<div className="absolute top-10 left-10">
							<Bot className="h-16 w-16" />
						</div>
						<div className="absolute top-20 right-16">
							<Sparkles className="h-12 w-12" />
						</div>
						<div className="absolute bottom-16 left-20">
							<Sparkles className="h-8 w-8" />
						</div>
						<div className="absolute bottom-10 right-10">
							<Bot className="h-20 w-20" />
						</div>
					</div>

					<div className="relative z-10">
						<h2 className="text-3xl md:text-5xl font-bold mb-6">
							Your Competition is Already
							<br />
							<span className="text-yellow-300">Training AI Agents</span>
						</h2>

						<p className="text-xl text-purple-100 mb-8 max-w-3xl mx-auto">
							While you're reading this, forward-thinking companies are deploying AI
							sales agents that work 24/7, never get tired, and consistently deliver
							results.
							<strong className="text-white"> Don't get left behind.</strong>
						</p>

						<div className="flex flex-col sm:flex-row gap-4 justify-center items-center mb-8">
							<Link href="/signup">
								<Button
									size="lg"
									className="bg-white text-purple-600 hover:bg-gray-50 text-lg px-8 py-4 rounded-xl shadow-lg hover:shadow-xl transition-all duration-200"
								>
									<Bot className="h-5 w-5 mr-2" />
									Start Training Agents Now
									<ArrowRight className="ml-2 h-5 w-5" />
								</Button>
							</Link>
							<div className="text-purple-200 text-sm">
								Free forever • No credit card required
							</div>
						</div>

						{/* Urgency indicators */}
						<div className="grid md:grid-cols-3 gap-6 max-w-4xl mx-auto text-center">
							<div className="bg-white/10 backdrop-blur-sm rounded-xl p-4">
								<div className="text-2xl font-bold text-yellow-300 mb-1">2,847</div>
								<div className="text-purple-100 text-sm">
									agents trained this month
								</div>
							</div>
							<div className="bg-white/10 backdrop-blur-sm rounded-xl p-4">
								<div className="text-2xl font-bold text-yellow-300 mb-1">$2.3M</div>
								<div className="text-purple-100 text-sm">
									revenue generated by AI agents
								</div>
							</div>
							<div className="bg-white/10 backdrop-blur-sm rounded-xl p-4">
								<div className="text-2xl font-bold text-yellow-300 mb-1">87%</div>
								<div className="text-purple-100 text-sm">
									increase in qualified leads
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
		</section>
	);
}
